import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './toasted'
import './modal'
import store from './store'

Vue.config.productionTip = false

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/styles/app.scss'

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
